<template>
  <v-dialog v-model="show" fullscreen>
    <v-container v-if="coupon">
      <v-row justify="space-around">
        <v-col cols="8">
          <v-layout>
            <v-img class="pt-0 pr-4" src="../../assets/warning_animation.gif">
            </v-img>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout class="titulo"
            >Abastecimento realizado com sucesso!</v-layout
          >
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout>
            <div class="subtitulo">
              Você acaba de ganhar um cupom para prorrogar sua
              <span style="font-weight: 600;">próxima reserva</span> por 30
              minutos.
            </div>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout>
            <div class="subtitulo">
              Para visualizar seus cupons, acesse sua carteira.
            </div>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="8">
          <div class="coupon" @click="copyCoupon('#coupon')">
            <input type="hidden" id="coupon" :value="coupon.name" />
            {{coupon.name}}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="text-center w-100 mt-4 pb-16">
            <v-btn
              large
              style="width: 96%"
              class="btnColor mx-0 white--text"
              @click="$emit('entendi')"
            >
              <span>ENTENDI</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row justify="space-around">
        <v-col cols="8">
          <v-layout>
            <v-img class="pt-0 pr-4" src="../../assets/checkmark.gif">
            </v-img>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout class="titulo"
            >Abastecimento realizado com sucesso!</v-layout
          >
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout>
            <div class="subtitulo">
              Ficamos muito felizes que você tenha abastecido o veículo!
            </div>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout>
            <div class="subtitulo">
              Por isso, você acaba de ganhar 30 minutos de prorrogação do seu <span style="font-weight: 600;">check-out.</span>
            </div>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout>
            <div class="subtitulo">
              Aproveite!
            </div>
          </v-layout>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="text-center w-100 mt-4 pb-16">
            <v-btn
              large
              style="width: 96%"
              class="btnColor mx-0 white--text"
              @click="$emit('entendi')"
            >
              <span>ENTENDI</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    coupon: Object
  },
  data() {
    return {};
  },
  methods: {
    copyCoupon(idSelector) {
      let codeToCopy = document.querySelector(idSelector);
      codeToCopy.setAttribute("type", "text");
      codeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        this.copy = successful ? "COPIADO" : "COPIAR";
      } catch (err) {
        console.log("Oops, unable to copy");
      }

      /* unselect the range */
      codeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
      this.$emit("copyCoupon");
    }
  }
};
</script>

<style scoped>
.titulo {
  font-family: "Sequel Sans";
  font-size: 20px;
  font-style: "normal";
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: "left";
}
.subtitulo {
  font-family: "Sequel Sans";
  font-size: 14px;
  font-style: "normal";
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: "left";
}
.coupon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background: rgba(151, 151, 151, 0.15);
}
</style>
